var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 18.125C4.13533 18.125 3.78559 18.2699 3.52773 18.5277C3.26987 18.7856 3.125 19.1353 3.125 19.5C3.125 20.1213 2.62132 20.625 2 20.625C1.37868 20.625 0.875 20.1213 0.875 19.5C0.875 18.5386 1.25692 17.6166 1.93674 16.9367C2.61656 16.2569 3.53859 15.875 4.5 15.875H18C18.6213 15.875 19.125 16.3787 19.125 17C19.125 17.6213 18.6213 18.125 18 18.125H4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.125C4.13533 3.125 3.78559 3.26987 3.52773 3.52773C3.26987 3.78559 3.125 4.13533 3.125 4.5V19.5C3.125 19.8647 3.26987 20.2144 3.52773 20.4723C3.78559 20.7301 4.13533 20.875 4.5 20.875H16.875V3.125H4.5ZM4.5 0.875H18C18.6213 0.875 19.125 1.37868 19.125 2V22C19.125 22.6213 18.6213 23.125 18 23.125H4.5C3.53859 23.125 2.61656 22.7431 1.93674 22.0633C1.25692 21.3834 0.875 20.4614 0.875 19.5V4.5C0.875 3.53859 1.25692 2.61656 1.93674 1.93674C2.61656 1.25692 3.53859 0.875 4.5 0.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c6a3a59be47ec599b5365251ca9e0c8b.svg";
export { ForwardRef as ReactComponent };